import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Avatar from '@src/pc/components/Avatar';

const ShootList = ({ content }) => {
    if (content.length <= 20) {
        for (let i = content.length; i < 20; i++) {
            content.push({
                rank: '',
                icon: '',
                name: '',
                country: '',
                jinqiu: '',
            });
        }
    }

    return (
        <div className={styles.shootList}>
            <table className={styles.shootTable1}>
                <thead className={styles.shootThead}>
                    <tr>
                        <th className={styles.shootTd}>排名</th>
                        <th className={styles.shootTd}>球员</th>
                        <th className={styles.shootTd}>球队</th>
                        <th className={styles.shootTd}>进球</th>
                    </tr>
                </thead>
            </table>
            <table className={styles.shootTable2}>
                <tbody className={styles.shootTbody}>
                    {content.map((item, index) => {
                        return (
                            <tr key={index} className={styles.shootTr}>
                                <td className={styles.shootTd}>{index + 1}</td>
                                <td className={styles.shootTd}>
                                    <div className={styles.player}>
                                        <div className={styles.playerPicBox}>
                                            <Avatar className={styles.playerPic} content={{ url: item.icon }} />
                                        </div>
                                        <div className={styles.playerName}>{item?.name || '-'}</div>
                                    </div>
                                </td>
                                <td className={styles.shootTd}>{item?.country || '-'}</td>
                                <td className={styles.shootTd}>{item?.jinqiu || '-'}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

ShootList.propTypes = {
    content: PropTypes.array,
};

export default errorBoundary(ShootList);
